import trustpilot1 from '../assets/icons/trust-pilot.svg';
import trustpilot2 from '../assets/icons/trustpilotstarsfr.svg';
import { WorldCupHero } from '../components/WorldCupHero';

export default function Home(){
    return(
        <>
        <section className="home-section relative overflow-hidden" id="home">
            <div className="main-content w-[95%] md:w-[85%] m-auto pt-8 sm:pt-10 lg:pt-10 pb-8 relative z-10">
                {/* Main Hero Banner */}
                <div className="bg-gradient-to-tr from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] rounded-3xl p-4 sm:p-8 lg:p-12 shadow-2xl relative overflow-hidden">
                    {/* Background Decoration */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                    
                    <div className="relative z-10">
                        {/* Trustpilot Rating */}
                        <div className="flex-row items-start gap-2 mb-6">
                            <img src={trustpilot1} alt="Trustpilot Rating" className='w-[115px]' />
                            <img src={trustpilot2} alt="Trustpilot Rating" className='w-[205px] mt-3' />
                        </div>

                        {/* Activation Badge */}
                        <div className="inline-flex items-center space-x-2 bg-black bg-opacity-30 backdrop-blur-sm px-4 py-2 rounded-full mb-8 border border-white border-opacity-20">
                            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd"/>
                            </svg>
                            <span className="text-white font-medium">Directe Activering</span>
                        </div>

                        {/* Main Headline */}
                        <div className="mb-6">
                            <h1 className="text-3xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
                                <span className="">Welkom bij{" "}</span>
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                  TVDIAMONDA
                                </span>
                                <span className="block">De Beste IPTV in</span>
                                <span className="block">Europa</span>
                            </h1>



                            <h2 className="text-lg sm:text-xl font-bold text-white mb-6">
                                Kwaliteit en Extra's voor Jouw Entertainment!
                            </h2>
                        </div>

                        {/* Service Description */}
                        <div className="mb-8">
                            <p className="text-sm sm:text-base text-white leading-relaxed max-w-4xl">
                                Geniet van IPTV met een indrukwekkende <span className="font-bold text-yellow-300">4K/Full HD</span> kwaliteit op elk apparaat, altijd en overal.
                                Toegang tot <span className="font-bold text-yellow-300">95.000+ kanalen</span> en <span className="font-bold text-yellow-300">249.000+ films en series (VOD)</span>
                                met <span className="font-bold text-yellow-300">100% uptime</span>.
                                Gratis activering van de IBO Pro Player 🎁 en directe start – zonder verborgen kosten.
                            </p>
                        </div>

                        {/* CTA Button */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button 
                                onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                                className="bg-white hover:bg-gray-100 text-gray-900 px-6 py-3 rounded-xl font-bold text-base transition-all duration-300 flex items-center justify-center space-x-2 shadow-2xl hover:shadow-3xl transform hover:scale-105"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"/>
                                </svg>
                                <span>BEKIJK PRIJZEN</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="mt-12 sm:mt-16 mb-4">
                    <WorldCupHero
                        onCtaClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                        ctaLabel="Bekijk Aanbiedingen"
                    />
                </div>

                {/* Feature Cards Section */}
                <div className="mt-12 sm:mt-16 relative px-3 md:px-0">
                    <div className="relative z-10">
                        {/* Dotted Background Pattern */}
                        <div className="absolute inset-0 opacity-20">
                            <div className=" h-64 w-full" style={{
                                backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                                backgroundSize: '20px 20px'
                            }}></div>
                        </div>
                        {/* Cards Container */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
                            {/* Card 1 - Channels */}
                            <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-lg hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1 hover:border hover:border-gray-200">
                                <div className="flex flex-col items-center text-center space-y-6">
                                    {/* TV Icon */}
                                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 256 256"><path fill="#2d3748" d="M168 224a8 8 0 0 1-8 8H96a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8m64-160v112a24 24 0 0 1-24 24H48a24 24 0 0 1-24-24V64a24 24 0 0 1 24-24h160a24 24 0 0 1 24 24m-68 56a8 8 0 0 0-3.41-6.55l-40-28A8 8 0 0 0 108 92v56a8 8 0 0 0 12.59 6.55l40-28A8 8 0 0 0 164 120"></path></svg>
                                    </div>
                                    
                                    {/* Title */}
                                    <h3 className="text-lg md:text-xl font-bold text-blue-900">
                                        Meer dan 79.000 kanalen van over de hele wereld
                                    </h3>

                                    {/* Description */}
                                    <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                        Een complete lijst van alle beschikbare Europese kanalen. Met meer dan 79.000 tv-kanalen bieden we je de meest complete kanalenlijst van de markt.
                                    </p>
                                </div>
                            </div>

                            {/* Card 2 - Ultra Fast Connection */}
                            <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-lg hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1 hover:border hover:border-gray-200">
                                <div className="flex flex-col items-center text-center space-y-6">
                                    {/* Lightning Icon */}
                                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 512 512"><path fill="#2d3748" d="M194.82 496a18.36 18.36 0 0 1-18.1-21.53v-.11L204.83 320H96a16 16 0 0 1-12.44-26.06L302.73 23a18.45 18.45 0 0 1 32.8 13.71c0 .3-.08.59-.13.89L307.19 192H416a16 16 0 0 1 12.44 26.06L209.24 489a18.45 18.45 0 0 1-14.42 7"></path></svg>
                                    </div>
                                    
                                    {/* Title */}
                                    <h3 className="text-lg md:text-xl font-bold text-blue-900">
                                        Ultrasnelle verbinding
                                    </h3>

                                    {/* Description */}
                                    <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                        In tegenstelling tot andere IPTV-providers gebruikt TVDIAMONDA een toegewijde Europese server van hoge kwaliteit. Het openen van onze tv-kanalen duurt minder dan 0,5 seconden.
                                    </p>
                                </div>
                            </div>

                            {/* Card 3 - Instant Installation */}
                            <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-lg hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1 hover:border hover:border-gray-200">
                                <div className="flex flex-col items-center text-center space-y-6">
                                    {/* Gift Box Icon */}
                                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 24 24"><g fill="none" fillRule="evenodd"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path><path fill="#2d3748" d="M20 13v5a3 3 0 0 1-3 3h-4v-8zm-9 0v8H7a3 3 0 0 1-3-3v-5zM9 2a4 4 0 0 1 3 1.354A4 4 0 0 1 15 2h.5A1.5 1.5 0 0 1 17 3.5V4c0 .729-.195 1.412-.535 2H19a2 2 0 0 1 2 2v2c0 .364-.097.706-.268 1H13V8a1 1 0 1 0-2 0v3H3.268A2 2 0 0 1 3 10V8a2 2 0 0 1 2-2h2.535A4 4 0 0 1 7 4v-.5A1.5 1.5 0 0 1 8.5 2Zm0 2a2 2 0 0 0 2 2a2 2 0 0 0-2-2m6 0a2 2 0 0 0-2 2a2 2 0 0 0 2-2"></path></g></svg>
                                    </div>
                                    
                                    {/* Title */}
                                    <h3 className="text-lg md:text-xl font-bold text-blue-900">
                                        Directe installatie
                                    </h3>

                                    {/* Description */}
                                    <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                        Je kunt je IPTV-abonnement eenvoudig instellen en installeren op elk apparaat. We maken het proces eenvoudig met gratis installatie op afstand en gratis activering van de IBO Pro Player.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}